import * as yup from "yup";

const p_wRegex = /^(?=.{8,})(?=.*[a-z])(?=.*[~`!@#$%^&*()_+=\-[\]{}|;:'",.<>/?\\]).*$/;
const rp_wRegex = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!@#$%^&*()_+=\-[\]{}|;:'",.<>/?\\]).*$/;
export const userSchema = yup.object().shape({
    fullName: yup.string().required("Full name is required").default(""),
    firstName: yup.string().required("First name is required").default(""),
    lastName: yup.string().required("Last name is required").default(""),
    email: yup.string().email("Invalid email format").required("Email is required").default(""),
    dateOfBirth: yup.string().nullable(),
    sex: yup.boolean().required("Sex is required").default(false),
    hometown: yup.string().required("Hometown is required").default(""),
    city: yup.string().required("City is required").default(""),
    country: yup.string().required("Country is required").default(""),
    phoneNumber: yup.string().required("Phone number is required").default(""),
    description: yup.string().nullable().default(""),
    roleId: yup.string().required("Role is required").default(""),
    //   file: yup.mixed().nullable(),
    file: yup.string().nullable(),
});

export const updatePasswordSchema = yup.object().shape({
    password: yup.string()
        .matches(p_wRegex, "Tối thiểu 8 ký tự, có it nhất 1 ký tự viết thường, hoa và ký tự đặc biệt")
        .required("Trường này là bắt buộc"),
    confirmPassword: yup.string()
        .oneOf([yup.ref("password"), undefined], "Mật khẩu không khớp")
        .required("Trường này là bắt buộc"),
});

export const resetPasswordSchema = yup.object().shape({
    password: yup.string()
        .matches(rp_wRegex, "Tối thiểu 8 ký tự, có it nhất 1 ký tự viết thường, hoa và ký tự đặc biệt")
        .required("Trường này là bắt buộc"),
    confirmPassword: yup.string()
        .oneOf([yup.ref("password"), undefined], "Mật khẩu không khớp")
        .required("Trường này là bắt buộc"),
});

export const changePasswordSchema = yup.object().shape({
    password: yup.string()
        .matches(rp_wRegex, "Tối thiểu 8 ký tự, có it nhất 1 ký tự viết thường, hoa và ký tự đặc biệt")
        .required("Trường này là bắt buộc"),
    confirmPassword: yup.string()
        .oneOf([yup.ref("password"), undefined], "Mật khẩu không khớp")
        .required("Trường này là bắt buộc"),
    currentPassword: yup.string()
        .matches(rp_wRegex, "Tối thiểu 8 ký tự, có it nhất 1 ký tự viết thường, hoa và ký tự đặc biệt")
        .required("Trường này là bắt buộc"),
});
